<template>
  <div class="header-wrapper" @mouseleave="handleMouseLeave">
    <div class="common-header">
      <div class="nav-list">
        <div class="nav-left">
          <div 
            :class="['nav-item', { active: activePath === item.path }]" 
            v-for="item in newNavList.slice(0, 4)" 
            :key="item.name" 
            @click="jump(item)"
            @mouseenter="handleMouseEnter(item, $event)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="" />
        </div>
        <div class="nav-right">
          <div 
            :class="['nav-item', { active: activePath === item.path }]" 
            v-for="item in newNavList.slice(4)" 
            :key="item.name" 
            @click="jump(item)"
            @mouseenter="handleMouseEnter(item, $event)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      
      <div v-if="isLogin" class="login">
         <el-button size="small" type="primary" class="btn" @click="loginVisible = true">立即登录</el-button>
      </div>
      <div v-else class="person-info">
        <el-avatar size="small" :src="userInfo?.headImg || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
        <el-dropdown style="margin-left: 12px">
          <span class="el-dropdown-link"> {{ userInfo?.nickName }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$router.push('/personal')">个人中心</el-dropdown-item>
            <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="submenu-container" :class="{ show: showSubmenu }" @mouseenter="handleSubmenuEnter" @mouseleave="handleMouseLeave">
      <div class="submenu-content" :style="{ paddingLeft: submenuPaddingLeft + 'px' }">
        <div 
          class="submenu-item" 
          v-for="sub in currentSubmenu" 
          :key="sub.name" 
          @click="jump(sub)"
        >
          {{ sub.name }}
        </div>
      </div>
    </div>
    <el-dialog
      title="票务预订"
      :visible.sync="dialogVisible"
      width="500px"
      :show-close="true"
      center
      append-to-body
    >
      <img src="@/assets/images/mini-code.jpg" style="width: 100%;" alt="">
      <template slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </template>
    </el-dialog>
    
    <login-register-dialog :visible.sync="loginVisible" />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import routerList from '@/router/config'
import { findTopLevelNavObjectByPath, removeDetails } from './utils'
import { travelUrl } from '@/config/travel'
import LoginRegisterDialog from '@/components/login-register-dialog.vue'

export default {
  name: 'common-header',
  components: {
    LoginRegisterDialog
  },
  data() {
    return {
      activePath: '',
      navList: routerList,
      currentSubmenu: [],
      showSubmenu: false,
      timer: null,
      submenuPaddingLeft: 0,
      dialogVisible: false
    }
  },
  computed: {
    ...mapState('common', ['homeList']),
    ...mapState('user', ['token', 'userInfo', 'loginDialogVisible']),
    loginVisible: {
      get() {
        return this.loginDialogVisible
      },
      set(val) {
        this.setLoginDialogVisible(val)
      }
    },
    isLogin() {
      return !this.token
    },
    newNavList() {
      const componentContent = this.findDetailContent(this.homeList, '/home', 'headers')
      if (!componentContent) return this.comNavList
      return componentContent.dataList
    },
    comNavList() {
      return removeDetails(this.navList)
    },
    
  },
  watch: {
    $route: {
      handler(newVal) {
        if (newVal.path !== '/' && this.navList) {
          this.activePath = findTopLevelNavObjectByPath(this.navList, newVal.path)?.path || ''
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    ...mapMutations('user', ['setLoginDialogVisible']),
    handleLogout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/')
      })
    },
    jump(item) {
      if (item.path === '/dialog') {
        if (['景区票务', '票务预订'].includes(item.name)) {
          this.dialogVisible = true
        }
        if (item.name === '旅行社购票') {
          window.open(travelUrl, '_blank')
        }
        return
      }
      if(item.name === '探索景区') return
      this.$router.push({
        path: item.path,
        // 取后台： 官网首页配置
        query: {
          articleCategoryId: item.type,
          id: item.value
        }
      })
      this.handleMouseLeave()
    },
    handleMouseEnter(item, event) {
      if (this.timer) clearTimeout(this.timer)
      
      if (event && event.target) {
        const itemRect = event.target.getBoundingClientRect();
        this.submenuPaddingLeft = itemRect.left;
      }

      if (item.children && item.children.length > 0) {
        this.currentSubmenu = item.children
        this.showSubmenu = true
      } else {
        this.showSubmenu = false
      }
    },
    handleSubmenuEnter() {
      if (this.timer) clearTimeout(this.timer)
      this.showSubmenu = true
    },
    handleMouseLeave() {
      this.timer = setTimeout(() => {
        this.showSubmenu = false
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
$activeColor: #5EA877;

.header-wrapper {
  position: relative;
  width: 100%;
  background: white;
  z-index: 1000;
}

.common-header {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;

  .nav-list {
    display: flex;
    .nav-left,
    .logo,
    .nav-right {
      display: flex;
      align-items: center;
      .nav-item {
        width: 120px;
        height: 79px;
        line-height: 79px;
        text-align: center;
        color: #505660;
        cursor: pointer;
        &:hover {
          color: $activeColor;
          font-weight: bold;
        }
        &.active {
          color: $activeColor;
          font-weight: bold;
          position: relative;
          &::after {
            content: '';
            display: block;
            width: 32px;
            height: 3px;
            background: $activeColor;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .logo img {
      width: 130px;
      height: 52px;
    }
  }
  
  .person-info,
  .login {
    display: flex;
    align-items: center;
    .btn {
      width: 96px;
      height: 36px;
      border: 1px solid;
    }
  }
}

.submenu-container {
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  background: rgba(240, 246, 255, 0.95);
  overflow: hidden;
  height: 0;
  transition: height 0.3s ease;
  border-top: 1px solid transparent;

  &.show {
    height: 60px;
    border-top: 1px solid #e0e0e0;
  }

  .submenu-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start; 
    box-sizing: border-box; 
    
    .submenu-item {
      padding: 0 30px;
      font-size: 16px;
      color: #7B8393;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      transition: color 0.3s;

      &:hover {
        color: $activeColor;
        font-weight: bold;
      }
    }
  }
}
</style>